export const dramas = [
  {
    id: "queen-of-tears",
    title: "泪之女王",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20artwork%2C%20elegant%20woman%20in%20cream%20silk%20coat%20standing%20in%20a%20softly%20lit%20modern%20Seoul%20apartment%2C%20warm%20rose%20and%20gold%20color%20palette%2C%20painterly%20digital%20illustration%2C%20romantic%20melancholic%20mood%2C%20soft%20film%20grain%2C%20no%20text&width=480&height=672&seq=kd-poster-01&orientation=portrait",
    genres: ["爱情", "家庭"],
    year: 2024,
    episodes: 16,
    currentEp: 16,
    score: 9.2,
    status: "热播中",
    tags: ["财阀", "虐恋", "高颜值"],
    synopsis:
      "百货集团继承人与乡下出身的丈夫在三年婚姻后走到悬崖边，一纸诊断书让两人不得不再度面对彼此，也重新认识了爱情与家族的分量。",
    exclusive: true,
    viewers: 1286,
    updateDate: "10-05",
    updateNote: "更新至第16集 大结局",
  },
  {
    id: "lovely-runner",
    title: "背着善宰跑",
    poster:
      "https://readdy.ai/api/search-image?query=Dreamy%20Korean%20drama%20poster%20artwork%2C%20young%20woman%20running%20through%20campus%20cherry%20blossoms%20turning%20back%20to%20smile%2C%20nostalgic%202000s%20high%20school%20atmosphere%2C%20pastel%20pink%20and%20mint%20tones%2C%20painterly%20digital%20illustration%2C%20tender%20hopeful%20mood%2C%20soft%20grain%2C%20no%20text&width=480&height=672&seq=kd-poster-02&orientation=portrait",
    genres: ["爱情", "奇幻"],
    year: 2024,
    episodes: 16,
    currentEp: 16,
    score: 8.9,
    status: "热播中",
    tags: ["穿越", "青春", "治愈"],
    synopsis:
      "为了救回意外离世的偶像，她一次次回到过去，试图改变命运。时间线不断重写，可她最想守护的人，也正一点点靠近她。",
    exclusive: false,
    viewers: 1042,
    updateDate: "10-04",
    updateNote: "更新至第16集 大结局",
  },
  {
    id: "when-the-phone-rings",
    title: "现在拨打的电话",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20Korean%20thriller%20poster%20artwork%2C%20elegant%20woman%20in%20a%20dark%20coat%20holding%20a%20vintage%20telephone%20in%20a%20dim%20corridor%2C%20deep%20crimson%20and%20charcoal%20palette%2C%20suspenseful%20noir%20lighting%2C%20painterly%20digital%20illustration%2C%20no%20text&width=480&height=672&seq=kd-poster-03&orientation=portrait",
    genres: ["悬疑", "爱情"],
    year: 2024,
    episodes: 12,
    currentEp: 12,
    score: 8.7,
    status: "热播中",
    tags: ["政界", "契约婚姻", "反转"],
    synopsis:
      "一通神秘的恐吓电话，牵扯出一段貌合神离的政治联姻。表面冷淡的夫妻在追查真相的过程中，被迫交出自保的铠甲。",
    exclusive: false,
    viewers: 968,
    updateDate: "10-05",
    updateNote: "更新至第12集 大结局",
  },
  {
    id: "good-partner",
    title: "好搭档",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20Korean%20legal%20drama%20poster%20artwork%2C%20confident%20female%20lawyer%20in%20a%20crisp%20blazer%20standing%20in%20a%20bright%20office%20with%20glass%20walls%2C%20warm%20cream%20and%20burgundy%20palette%2C%20clean%20editorial%20illustration%2C%20no%20text&width=480&height=672&seq=kd-poster-04&orientation=portrait",
    genres: ["职场", "法律"],
    year: 2024,
    episodes: 16,
    currentEp: 14,
    score: 8.5,
    status: "热播中",
    tags: ["离婚律师", "双女主", "爽剧"],
    synopsis:
      "明星离婚律师与新手搭档在一次次棘手的案件中磨合，处理别人婚姻的同时，也照见自己生活里那些不愿面对的裂缝。",
    exclusive: false,
    viewers: 812,
    updateDate: "10-04",
    updateNote: "更新至第14集",
  },
  {
    id: "judge-from-hell",
    title: "来自地狱的法官",
    poster:
      "https://readdy.ai/api/search-image?query=Dark%20fantasy%20Korean%20drama%20poster%20artwork%2C%20stern%20female%20judge%20in%20a%20black%20robe%20with%20subtle%20ember%20glow%20behind%20her%2C%20deep%20red%20and%20smoke%20grey%20palette%2C%20gothic%20painterly%20digital%20illustration%2C%20ominous%20elegant%20mood%2C%20no%20text&width=480&height=672&seq=kd-poster-05&orientation=portrait",
    genres: ["奇幻", "犯罪"],
    year: 2024,
    episodes: 14,
    currentEp: 8,
    score: 8.3,
    status: "热播中",
    tags: ["恶魔", "惩恶", "强力女主人设"],
    synopsis:
      "来自地狱的使者附身法官，用她自己的方式审判那些钻法律空子的恶人。而一个正义感过剩的刑警，正紧盯着她不放。",
    exclusive: false,
    viewers: 764,
    updateDate: "10-05",
    updateNote: "更新至第8集",
  },
  {
    id: "madame-ok",
    title: "玉氏夫人传",
    poster:
      "https://readdy.ai/api/search-image?query=Traditional%20Korean%20historical%20drama%20poster%20artwork%2C%20noblewoman%20in%20ornate%20hanbok%20standing%20in%20a%20lantern-lit%20courtyard%20of%20a%20hanok%2C%20rich%20gold%20and%20deep%20rose%20palette%2C%20opulent%20painterly%20illustration%2C%20period%20drama%20elegance%2C%20no%20text&width=480&height=672&seq=kd-poster-06&orientation=portrait",
    genres: ["古装", "剧情"],
    year: 2024,
    episodes: 16,
    currentEp: 12,
    score: 8.4,
    status: "热播中",
    tags: ["朝鲜时代", "身份逆袭", "女性成长"],
    synopsis:
      "失去一切的奴婢之女，冒用贵族身份在朝鲜最繁华的市集里活下去。她靠一双手挣出名声，也步步走进时代的风暴中心。",
    exclusive: true,
    viewers: 690,
    updateDate: "10-03",
    updateNote: "更新至第12集",
  },
  {
    id: "jeongnyeon",
    title: "正年",
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20period%20music%20drama%20poster%20artwork%2C%20young%20woman%20in%20traditional%20stage%20costume%20singing%20under%20warm%20spotlights%2C%20deep%20indigo%20rose%20and%20gold%20palette%2C%20theatrical%20painterly%20illustration%2C%20expressive%20elegant%20mood%2C%20no%20text&width=480&height=672&seq=kd-poster-07&orientation=portrait",
    genres: ["古装", "音乐"],
    year: 2024,
    episodes: 12,
    currentEp: 10,
    score: 8.6,
    status: "最新更新",
    tags: ["盘索里", "剧团", "追梦"],
    synopsis:
      "木浦少女天生一副好嗓子，只身闯进首尔的国剧团。在同行倾轧与旧规矩之间，她要用声音闯出属于自己的舞台。",
    exclusive: false,
    viewers: 588,
    updateDate: "10-05",
    updateNote: "更新至第10集",
  },
  {
    id: "gyeongseong-creature",
    title: "京城怪物",
    poster:
      "https://readdy.ai/api/search-image?query=Retro%20horror%20Korean%20drama%20poster%20artwork%2C%20detective%20and%20shopkeeper%20standing%20in%20a%20foggy%201940s%20Seoul%20alley%20with%20glowing%20lanterns%2C%20muted%20teal%20and%20amber%20palette%2C%20vintage%20suspenseful%20painterly%20illustration%2C%20no%20text&width=480&height=672&seq=kd-poster-08&orientation=portrait",
    genres: ["奇幻", "悬疑"],
    year: 2024,
    episodes: 10,
    currentEp: 10,
    score: 7.9,
    status: "最新更新",
    tags: ["年代", "怪物", "双主角"],
    synopsis:
      "1945 年的京城，当铺的年轻主人与侦探联手调查一连串失踪案。线索尽头，是殖民地阴影下一场被隐藏的人体实验。",
    exclusive: false,
    viewers: 512,
    updateDate: "10-02",
    updateNote: "全10集 已完结",
  },
  {
    id: "moving",
    title: "超异能族",
    poster:
      "https://readdy.ai/api/search-image?query=Superhero%20family%20Korean%20drama%20poster%20artwork%2C%20teenagers%20with%20glowing%20silhouettes%20standing%20on%20a%20rooftop%20against%20a%20dusk%20sky%2C%20warm%20amber%20and%20deep%20navy%20rose%20palette%2C%20epic%20painterly%20digital%20illustration%2C%20no%20text&width=480&height=672&seq=kd-poster-09&orientation=portrait",
    genres: ["奇幻", "动作"],
    year: 2023,
    episodes: 20,
    currentEp: 20,
    score: 9.0,
    status: "已完结",
    tags: ["超能力", "家庭", "群像"],
    synopsis:
      "几个看似普通的高中生，各自藏着不会老、能飞、能自愈的秘密。父辈那场被抹去的往事，正随着追杀一步步浮出水面。",
    exclusive: false,
    viewers: 1478,
    updateDate: "09-28",
    updateNote: "全20集 全集在线",
  },
  {
    id: "the-glory",
    title: "黑暗荣耀",
    poster:
      "https://readdy.ai/api/search-image?query=Revenge%20Korean%20drama%20poster%20artwork%2C%20woman%20in%20a%20black%20coat%20standing%20before%20a%20chessboard%20in%20a%20shadowy%20room%2C%20deep%20black%20and%20blood%20rose%20palette%2C%20stark%20elegant%20painterly%20illustration%2C%20cold%20determined%20mood%2C%20no%20text&width=480&height=672&seq=kd-poster-10&orientation=portrait",
    genres: ["复仇", "悬疑"],
    year: 2023,
    episodes: 16,
    currentEp: 16,
    score: 9.1,
    status: "已完结",
    tags: ["校园暴力", "复仇", "高智商"],
    synopsis:
      "被校园暴力毁掉人生的女人，用十几年时间把所有加害者一一编进自己的棋局。她要的不是道歉，而是让他们亲手毁掉彼此。",
    exclusive: true,
    viewers: 1633,
    updateDate: "09-25",
    updateNote: "全16集 全集在线",
  },
  {
    id: "my-liberation-notes",
    title: "我的解放日志",
    poster:
      "https://readdy.ai/api/search-image?query=Quiet%20healing%20Korean%20drama%20poster%20artwork%2C%20three%20siblings%20standing%20on%20a%20rural%20hillside%20road%20at%20golden%20hour%2C%20warm%20sand%20and%20sage%20palette%2C%20contemplative%20painterly%20illustration%2C%20soft%20nostalgic%20mood%2C%20no%20text&width=480&height=672&seq=kd-poster-11&orientation=portrait",
    genres: ["剧情", "治愈"],
    year: 2022,
    episodes: 16,
    currentEp: 16,
    score: 8.8,
    status: "已完结",
    tags: ["乡村", "压抑", "写实"],
    synopsis:
      "住在京畿道尽头的三兄妹，每天通勤两小时去首尔打工。他们没有大起大落的人生，只在一次次沉默里，慢慢学会和解。",
    exclusive: false,
    viewers: 742,
    updateDate: "09-20",
    updateNote: "全16集 全集在线",
  },
  {
    id: "twenty-five",
    title: "二十五，二十一",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20youth%20Korean%20drama%20poster%20artwork%2C%20two%20teenagers%20on%20bicycles%20by%20the%20sea%20at%20sunset%20in%20the%20late%201990s%2C%20warm%20peach%20and%20sky%20sage%20palette%2C%20tender%20painterly%20illustration%2C%20hopeful%20bittersweet%20mood%2C%20no%20text&width=480&height=672&seq=kd-poster-12&orientation=portrait",
    genres: ["青春", "爱情"],
    year: 2022,
    episodes: 16,
    currentEp: 16,
    score: 8.7,
    status: "已完结",
    tags: ["击剑", "年代", "青春群像"],
    synopsis:
      "金融危机那年，击剑队的少女与被迫辍学的少年在乡下相遇。时代夺走了他们很多东西，却也留下了那一年最亮的光。",
    exclusive: false,
    viewers: 806,
    updateDate: "09-18",
    updateNote: "全16集 全集在线",
  },
  {
    id: "reborn-rich",
    title: "财阀家的小儿子",
    poster:
      "https://readdy.ai/api/search-image?query=Corporate%20revenge%20Korean%20drama%20poster%20artwork%2C%20young%20businessman%20in%20a%20sharp%20suit%20standing%20before%20a%20glass%20tower%20at%20dusk%2C%20deep%20burgundy%20and%20gold%20palette%2C%20sleek%20painterly%20illustration%2C%20ambitious%20mood%2C%20no%20text&width=480&height=672&seq=kd-poster-13&orientation=portrait",
    genres: ["奇幻", "复仇"],
    year: 2022,
    episodes: 16,
    currentEp: 16,
    score: 8.2,
    status: "已完结",
    tags: ["重生", "财阀", "商战"],
    synopsis:
      "被家族灭口的秘书重生成会长的小孙子。带着前世记忆，他要在同一个家族里，一步一步拿回本该属于自己的一切。",
    exclusive: false,
    viewers: 918,
    updateDate: "09-15",
    updateNote: "全16集 全集在线",
  },
  {
    id: "familiar-wife",
    title: "认识的妻子",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20Korean%20drama%20poster%20artwork%2C%20couple%20looking%20at%20each%20other%20in%20two%20mirrored%20timelines%2C%20warm%20rose%20and%20soft%20cream%20palette%2C%20whimsical%20dual-scene%20painterly%20illustration%2C%20no%20text&width=480&height=672&seq=kd-poster-14&orientation=portrait",
    genres: ["爱情", "奇幻"],
    year: 2023,
    episodes: 16,
    currentEp: 16,
    score: 7.8,
    status: "已完结",
    tags: ["平行时空", "婚姻", "轻喜剧"],
    synopsis:
      "一段倦怠的婚姻，因为一次时空错位变成了两种人生。当他同时看着两个版本的妻子，才明白自己弄丢的到底是什么。",
    exclusive: false,
    viewers: 466,
    updateDate: "09-12",
    updateNote: "全16集 全集在线",
  },
  {
    id: "bad-mother",
    title: "坏的妈妈",
    poster:
      "https://readdy.ai/api/search-image?query=Family%20drama%20Korean%20drama%20poster%20artwork%2C%20mother%20and%20grown%20daughter%20sitting%20apart%20in%20a%20warm%20kitchen%20with%20morning%20light%2C%20soft%20taupe%20and%20sage%20palette%2C%20gentle%20painterly%20illustration%2C%20introspective%20mood%2C%20no%20text&width=480&height=672&seq=kd-poster-15&orientation=portrait",
    genres: ["家庭", "剧情"],
    year: 2024,
    episodes: 12,
    currentEp: 12,
    score: 8.0,
    status: "已完结",
    tags: ["母女", "现实", "催泪"],
    synopsis:
      "一个曾经抛下孩子的母亲，晚年带着秘密回到女儿身边。两人在同一屋檐下小心翼翼地试探，把多年的心结一点点拆开。",
    exclusive: false,
    viewers: 398,
    updateDate: "09-30",
    updateNote: "全12集 全集在线",
  },
  {
    id: "big-mouth",
    title: "黑话律师",
    poster:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20Korean%20drama%20poster%20artwork%2C%20man%20in%20a%20rumpled%20suit%20holding%20legal%20files%20in%20a%20dim%20prison%20corridor%2C%20deep%20charcoal%20and%20amber%20palette%2C%20gritty%20painterly%20illustration%2C%20no%20text&width=480&height=672&seq=kd-poster-16&orientation=portrait",
    genres: ["犯罪", "法律"],
    year: 2023,
    episodes: 16,
    currentEp: 16,
    score: 7.9,
    status: "已完结",
    tags: ["越狱", "诈骗犯", "反转"],
    synopsis:
      "一名胜率只有一成的小律师被卷进巨额诈骗案，为自保他干脆扮成传说中的天才骗子，在监狱内外同时下一盘险棋。",
    exclusive: false,
    viewers: 452,
    updateDate: "09-10",
    updateNote: "全16集 全集在线",
  },
  {
    id: "destined-with-you",
    title: "恋爱不可抗力",
    poster:
      "https://readdy.ai/api/search-image?query=Supernatural%20romance%20Korean%20drama%20poster%20artwork%2C%20woman%20in%20a%20green%20trench%20coat%20holding%20an%20old%20forbidden%20book%20surrounded%20by%20drifting%20petals%2C%20warm%20emerald%20and%20rose%20palette%2C%20magical%20painterly%20illustration%2C%20no%20text&width=480&height=672&seq=kd-poster-17&orientation=portrait",
    genres: ["爱情", "奇幻"],
    year: 2024,
    episodes: 16,
    currentEp: 16,
    score: 8.1,
    status: "已完结",
    tags: ["禁书", "诅咒", "办公室恋情"],
    synopsis:
      "一名公务员意外得到一本三百年无人打开的禁书，从此被卷入不可思议的绯闻。而她越是躲，命运越把她推向他。",
    exclusive: true,
    viewers: 534,
    updateDate: "10-01",
    updateNote: "全16集 全集在线",
  },
  {
    id: "boyhood",
    title: "少年时代",
    poster:
      "https://readdy.ai/api/search-image?query=Comedy%20youth%20Korean%20drama%20poster%20artwork%2C%20scruffy%20high%20schooler%20standing%20in%20a%20dusty%201980s%20provincial%20town%20street%2C%20warm%20ochre%20and%20faded%20green%20palette%2C%20playful%20retro%20painterly%20illustration%2C%20no%20text&width=480&height=672&seq=kd-poster-18&orientation=portrait",
    genres: ["青春", "喜剧"],
    year: 2024,
    episodes: 10,
    currentEp: 6,
    score: 8.3,
    status: "最新更新",
    tags: ["校园", "年代", "无厘头"],
    synopsis:
      "1980 年代忠清道的小城少年，人生最大目标就是不被欺负、追到校花。荒唐的日常，拼出一个又好笑又热血的青春。",
    exclusive: false,
    viewers: 356,
    updateDate: "10-05",
    updateNote: "更新至第6集",
  },
];